/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare
import { Skeleton, Space, Text } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { useLingui } from '@lingui/react';
import { useElementSize } from '@mantine/hooks';
import { useModals } from '@mantine/modals';
import { useParams } from 'react-router-dom';
import { fetchDocumentsByEvent } from '../../../Service/restapi/documentService';
import { EventParticipationsContext } from '../../../Service/Context/EventParticipationContextV2';
import PanePaper from '../../PanePaper';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import BookitupTable from '../../../Atoms/BookitupTable';
import { TestS } from '../../../TestS';
import BookitupTutorialIcon from '../../../Atoms/BookitupTutorialIcon';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import DocumentListItem from './DocumentListItem';
import CreateDocumentModal from './CreateDocumentModal';

const DocumentPane = () => {
  const { i18n } = useLingui();
  const { id: eventId } = useParams();
  const { openLicenceModal } = useContext(ViolationContext);
  const eventParticipantsContext = useContext(EventParticipationsContext);
  const { customer } = eventParticipantsContext;
  const [isLoading, setLoading] = useState(false);
  const [documents, setDocuments] = useState();
  const [sortedDocuments, setSortedDocuments] = useState();
  const { ref, width } = useElementSize();
  const { openModal } = useModals();
  const { id: customerId } = customer ?? {};

  const openCreateDocumentModal = () => {
    openModal({
      size: 'sm',
      title: (
        <Text weight="bolder" size="xl" sx={{ lineHeight: 1.2 }}>
          Vorlage wählen
        </Text>
      ),
      closeOnEscape: true,
      transition: 'slide-down',
      children: (
        <CreateDocumentModal
          initialCustomerId={customerId}
          eventId={eventId}
          eventParticipationContext={eventParticipantsContext}
          openLicenceModal={openLicenceModal}
        />
      ),
    });
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  useEffect(() => {
    if (documents) {
      const tmpSortedDocuments = {};
      ['OFFER', 'CONFIRMATION', 'PARTIAL_INVOICE', 'INVOICE', 'REMINDER', 'CANCEL'].forEach((docType) => {
        const filteredDocs = documents.filter((d) => d.documentType === docType);
        if (filteredDocs.length > 0) {
          tmpSortedDocuments[docType] = filteredDocs;
        }
      });
      setSortedDocuments(tmpSortedDocuments);
    }
  }, [documents]);

  function fetchDocuments() {
    setLoading(true);
    setDocuments(undefined);
    fetchDocumentsByEvent(eventId)
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((newDocuments) => {
            setDocuments(newDocuments);
          });
        } else {
          console.error(`could not load documents of event ${eventId}`);
        }
      })
      .catch((error) => {
        console.error(`could not load documents of event ${eventId}`);
        console.error({ error });
      })
      .finally(() => setLoading(false));
  }

  const showColumns = {
    showNumber: width > 490,
    showDatum: width > 540,
    showName: width > 700,
    showDueDate: width > 400,
    showPortal: width >= 240,
    narrowPortalStatus: width < 290,
    showSum: true,
  };

  return (
    <PanePaper
      title="common.documents"
      tooltip="help.event.documents.pane"
      rightSection={
        <>
          <BookitupTutorialIcon
            videoUrl={'https://app.bookitup.de/academy/channels/offer-service?episodeId=tfl5yj1fg2'}
            name={'CreateDocument'}
          />
          <BookitupAddIcon onClick={openCreateDocumentModal} testId={TestS.Documents.CREATE_DOCUMENT} />
        </>
      }
    >
      <div ref={ref}>
        {isLoading ? (
          <div>
            {Array.from(Array(3)).map(() => (
              <Skeleton key={Math.random()} radius="md" height={25} width="100%" mb={10} />
            ))}
          </div>
        ) : (
          <div>
            {!documents || !sortedDocuments || documents.length === 0 ? (
              <Text italic color="dimmed" size="xs" weight="lighter">
                Noch nichts hinzugefügt.
              </Text>
            ) : (
              <BookitupTable>
                <thead>
                  <tr>
                    <th style={{ width: 70 }}>Status</th>
                    {showColumns.showNumber && <th style={{ width: 50 }}>Nummer</th>}
                    {showColumns.showName && <th>Name </th>}
                    {showColumns.showDatum && <th style={{ width: 50 }}>Datum</th>}
                    <th style={{ width: 100 }}>Betrag</th>
                    {showColumns.showDueDate && <th style={{ width: 100 }}>Frist</th>}
                    {showColumns.showPortal && (
                      <th style={{ width: showColumns.narrowPortalStatus ? 50 : 120 }}>Portal</th>
                    )}
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(sortedDocuments).map((key) => {
                    const docs = sortedDocuments[key];
                    return (
                      <>
                        <tr className="notHover" style={{ backgroundColor: 'transparent' }}>
                          <td colSpan={6}>
                            <Text weight="bolder">
                              <b> {i18n._(`document.${key.toLowerCase()}`)}</b>
                            </Text>
                          </td>
                        </tr>
                        {docs.map((doc) => (
                          <DocumentListItem
                            key={doc.id}
                            bookitupDocument={doc}
                            reload={() => fetchDocuments()}
                            {...showColumns}
                          />
                        ))}
                        <Space h="md" />
                      </>
                    );
                  })}
                </tbody>
              </BookitupTable>
            )}
          </div>
        )}
      </div>
    </PanePaper>
  );
};

export default DocumentPane;
